module.exports = __webpack_public_path__ + "img/Perspektive 12-31-07.30787547.jpg";